import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/logo_IAM.png'
import _imports_1 from '../../assets/img/logo_derecha.jpg'


const _hoisted_1 = { class: "container p-0 mt-0 mt-sm-12 mt-md-10 mt-lg-15 mx-auto" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 col-md-6 col-sm-6 align-self-start text-sm-start text-lg-start text-md-start textoCentrado" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo del Instituto Aragonés de la Mujer",
  class: "img-fluid",
  style: {"width":"220px"}
}, null, -1)
const _hoisted_5 = { class: "col-lg-6 col-md-6 col-sm-6 align-self-end mt-3 mt-sm-3 text-lg-end text-md-end text-sm-end textoCentrado" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid logoMain",
  src: _imports_1,
  alt: "Logos del Ministerio de Igualdad, Pacto de Estado y Gobierno de Aragón"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}